import { Component, ElementRef, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { modalSmall, modalLarge } from '../../../../shared/modules/dialogOptions'
import { IssueType1Model, IssueType2Model, IssueWebModel, SiteModel, TenantsModel } from '../../../../models';
import { IssueType1Service, IssueType2Service, IssueType3Service, IssueWebService, SettingsService, SiteService, TenantService } from '../../../../services';

@Pipe({ name: 'dateFormat' })
export class MomentPipes implements PipeTransform {
    transform(value: Date | moment.Moment, dateFormat: string): any {

        var offset = new Date().getTimezoneOffset();
        return moment(value).add(Math.abs(offset), "minutes").format('YYYY-MM-dd HH:mm');
        //return moment(value).format(dateFormat);
    }
}

@Component({
    selector: 'app-issue-web-create-public',
    templateUrl: './issue-web-create-public.component.html',
    styleUrls: ['./issue-web-create-public.component.scss']
})
export class IssueWebCreatePublicComponent implements OnInit {
    @ViewChild('fileUpload')
    myInputVariable: ElementRef;
    IssueType2: string = "Issue Type 2";
    IssueType1: string = "Issue Type 1";
    IssueType3: string = "Issue Type 3";
    showSpinner: boolean;
    isSending: boolean = false;
    isPreselected: boolean = false;
    ImageStack: string[];
    isAdminOrUserEditor: boolean;
    currentUser: any;
    photoSrc: string | ArrayBuffer;
    site: SiteModel;
    issueType1List: IssueType1Model[] = [];
    issueType2List: IssueType2Model[] = [];
    issueType3List: any[] = [];
    loadOtherPage: boolean;
    isLoaded: boolean = false;
    webPage: string = "";
    captcha: string = "";
    siteName: string = "";
    public option1: any = {
        enabled: false,
        name: ''
    };
    public option2: any = {
        enabled: false,
        name: ''
    };
    public option3: any = {
        enabled: false,
        name: '',
        id: 0
    };

    public selectedOption = "option1";
    Id: any;
    tenants: TenantsModel[] = [];
    model: IssueWebModel = new IssueWebModel();
    publicTextSetting: any;
    publicContacts: any[] = [];
    publicContactsData: any[] = [];
    ContactTypeId: number;
    constructor(private siteService: SiteService,
        private tenantService: TenantService,
        public router: Router,
        private route: ActivatedRoute,
        private issueType1Service: IssueType1Service,
        private issueType2Service: IssueType2Service,
        private issueType3Service: IssueType3Service,
        private settingService: SettingsService,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private issueWebService: IssueWebService) { }

    ngOnInit() {
        this.ImageStack = [];
        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];
                this.Id = id;
                //   
                this.siteService.getByGuid(id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.isLoaded = true;
                        var siteName = response.Data.Name
                        var id = response.Data.Id

                        const siteLinks = [
                            { site: "Mall Of Scandinavia", sublink: "4" },
                            { site: "Nacka Forum", sublink: "6" },
                            { site: "Täby Centrum", sublink: "5" },
                            { site: "Solna Centrum", sublink: "7" },
                        ]

                        const siteLink = siteLinks.find(x => x.site == siteName);

                        if (siteLink != null) {
                            this.setPublicPage(siteLink.sublink, siteLink.site);
                        }

                        this.loadTenant(response.Data.AccountId);
                        this.loadIssueType1(response.Data.AccountId);
                        this.loadIssueType2(response.Data.AccountId);
                        this.loadIssueType3(response.Data.AccountId);

                        this.loadSite(id);
                        this.model.SiteId = +id;
                        this.loadSettings(id, response.Data.AccountId);
                    });


                //this.loadData(id);

            }

        });

        this.setDefaults();
        //this.loadSites(this.currentUser.accountId);

    }
    showResponse(event) {
        //this.messageService.add({severity:'info', summary:'Succees', detail: 'User Responded'});
    }

    loadSettings(id: number, accountId: number) {

        //let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("IssueType1", accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType1 = response.Data.Value;
                }
            });

        this.settingService.getValue("IssueType2", accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType2 = response.Data.Value;
                }
            });

        this.settingService.getValue("IssueType3", accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType3 = response.Data.Value;
                }
            });

        this.settingService.getValue("publictext", accountId, +id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {

                if (response.Data != null) {
                    this.publicTextSetting = response.Data.Value;
                }
            });

        this.settingService.getValue("PublicPageContactOptions", accountId, this.model.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {

                if (response.Data != null) {

                    //this.publicContacts = response.Data.Value;

                    //this.publicContacts = response.Data.Value.split(',');

                    this.tenantService.getTenantListByCSV(response.Data.Value)
                        .catch((err: any) => {
                            return Observable.throw(err);
                        })
                        .finally(() => {
                            setTimeout(() => {
                            }, 1000);
                        })
                        .subscribe((response: any) => {
                            // 
                            if (response.Data != null) {
                                // 
                                this.publicContactsData = response.Data;

                            }
                        });
                }
            });

        this.settingService.getValue("option1", accountId, +id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {

                if (response.Data != null) {

                    var res = response.Data.Value.split("-");
                    this.option1.enabled = (res[0] === 'true');
                    this.option1.name = res[1];
                }
            });

        this.settingService.getValue("option2", accountId, +id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {

                    var res = response.Data.Value.split("-");
                    this.option2.enabled = (res[0] === 'true');
                    this.option2.name = res[1];
                }
            });

        this.settingService.getValue("option3", accountId, +id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {

                    var res = response.Data.Value.split("-");
                    this.option3.enabled = (res[0] === 'true');
                    //this.option2.name = res[1];
                }
            });

    }

    selectContact(item: any) {
        this.model.TenantId = item.Id;
        this.isPreselected = true;
        this.selectedOption = 'option3';
    }

    deselectContact(selected: string) {
        this.model.TenantId = 0;
        this.isPreselected = false;
        this.selectedOption = selected;
    }

    public validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    public isValidPhone(p) {
        var phoneRe = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        var digits = p;
        return phoneRe.test(digits);
    }

    saveChanges() {

        if (this.selectedOption == 'option1') {
            if (this.model.TenantId == 0 || this.model.TenantId == undefined) {
                this.toastr.warning("Please select a contact", "Error");
                return;
            }
        }

        if (this.selectedOption == 'option2') {
            if (this.model.ApartmentNumber == '' || this.model.ApartmentNumber == undefined) {
                this.toastr.warning("Please provide apartment number", "Error");
                return;
            }
        }

        if (this.selectedOption == 'option3') {

        }

        if (!this.validateEmail(this.model.Email)) {
            this.toastr.error("Invalid Email Address", "Error");
            return;
        }

        if (!this.isValidPhone(this.model.Phone)) {
            this.toastr.error("Invalid Phone Number", "Error");
            return;
        }

        //console.log(this.model);
        this.isSending = true;
        //this.model.AccountId = this.currentUser.accountId;

        this.model.IssueType3 = this.issueType3List;

        var index = 0;

        this.ImageStack.forEach(element => {

            if (index == 0) {
                this.model.Image = element;
            }
            if (index == 1) {
                this.model.Image2 = element;
            }
            if (index == 2) {
                this.model.Image3 = element;
            }
            if (index == 3) {
                this.model.Image4 = element;
            }
            if (index == 4) {
                this.model.Image5 = element;
            }

            index++;
        });

        this.issueWebService.saveIssue(this.model)
            .catch((err: any) => {

                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                if (!response.Success) {
                    this.isSending = false
                    this.toastr.warning(response.Message, "Warning")
                    return;
                }
                //this.router.navigate([`/issues`], { relativeTo: this.route }); 
                this.toastr.success(response.Message, "Success");
                this.model = new IssueWebModel();
                //   this.router.navigate([`issues/:id/confirm-create`], { relativeTo: this.route }); 
                this.router.navigate([`/issues/${this.Id}/confirm-create`], { relativeTo: this.route });
                //   this.myInputVariable.nativeElement.value = "";
                //   this.ngOnInit();
                //   this.isSending = false;

            });

    }

    public fileChange(fileInput: any) {
        let self = this;
        let file = <File>fileInput.target.files[0];
        if (file.size > 2000000) {
            // this.toastr.error(`Photo upload limits 2MB of file, this file is ${ (file.size / 1024 / 1024).toFixed(2) } KB. Please choose another one.`, "Error");
            return false;
        }
        var reader = new FileReader();
        reader.onload = function() {
            self.model.Image = reader.result;
            //image.photoString = reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
            self.photoSrc = reader.result;

            var t = "" + reader.result;
            self.ImageStack.push(t);

            self.photoSrc = '/assets/images/upload-empty.png';
            self.model.Image = '';
            // self.myInputVariable.nativeElement.value = "";
            self.modalRef.close();
        };
        reader.onerror = function(error) {
            console.log('Error: ', error);
        };

        reader.readAsDataURL(file);
    }
    modalRef: NgbModalRef;
    openSettings(settingsContent: string) {
        this.modalRef = this.modalService.open(settingsContent, modalSmall);
    }

    public removeImage(index) {
        // this.photoSrc = '/assets/images/upload-empty.png';
        // this.model.Image = '';
        // this.myInputVariable.nativeElement.value = "";
        this.ImageStack.splice(index, 1);

    }

    public setDefaults() {
        let now = new Date();
        this.photoSrc = "/assets/images/upload-empty.png";
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // if(this.currentUser.role === 'admin')
        // {
        //     this.isAdminOrUserEditor = true;
        // }
        // else if(this.currentUser.role === 'user')
        // {
        //     this.isAdminOrUserEditor = false;
        // }
    }

    // public AddImage(path: any){
    //     this.ImageStack.push(path);
    // };

    loadSite(siteId: number) {

        this.siteService.getSite(siteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.site = response.Data;
                //this.loadSettings();
                // if(localStorage.getItem('currentSiteId') != null){
                //   this.model.SiteId = +localStorage.getItem('currentSiteId');
                //   this.model.IssueType1Id =0;
                //   this.model.IssueType2Id=0;
                //   //alert(this.SiteId);
                // }
                //  this.toastr.success(response.Message, "Success"); 
            });
    }

    loadTenant(accountId: number) {

        this.settingService.getValue("ContactType", accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.ContactTypeId = +response.Data.Value;

                    this.tenantService.getTenantByTenantTypeId(this.model.SiteId, this.ContactTypeId)
                        .catch((err: any) => {
                            return Observable.throw(err);
                        })
                        .finally(() => {
                            setTimeout(() => {
                                //this.showSpinner = false;
                            }, 1000);
                        })
                        .subscribe((response: any) => {
                            //this.loadingTenant = false;
                            // 
                            this.tenants = response.Data.filter(x => x.IsActive);
                            // this.toastr.success(response.Message, "Success"); 
                        });
                }
            });
    }

    loadIssueType1(accountId: number) {
        this.issueType1Service.GetAll(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.issueType1List = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }

    loadIssueType2(accountId: number) {
        this.issueType2Service.GetAll(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.issueType2List = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }

    public setPublicPage(url: string, siteName: string) {
        this.webPage = `https://dedu.se/deduwebextern/rodamco/#!/property/${url}`
        this.siteName = siteName
        return;
    }


    loadIssueType3(accountId: number) {
        this.issueType3Service.GetAll(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                response.Data.forEach(element => {
                    this.issueType3List.push({
                        IssueType3Id: element.Id,
                        Value: element.Value,
                        Name: element.Name
                    });
                });

                //this.issueType3List = response.Data;

            });

    }


}



// WEBPACK FOOTER //
// ./src/app/components/IssueWeb/public/issue-web-create-public/issue-web-create-public.component.ts